export default {
    'add-new-exam': 'Add new exam',
    'edit-exam': 'Edit exam'
}